import './suppressCrossOriginScriptErrors';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import 'antd/dist/reset.css';
import './index.css';
import App from './App';

// Erreurs réelles (hors "Script error." opaque) — voir suppressCrossOriginScriptErrors.ts
window.addEventListener(
  'error',
  (event) => {
    const msg = event.message || '';
    if (msg === 'Script error.' || msg === 'Script error') return;
    console.error('Global error:', event.error || event.message, event.filename);
  },
  true,
);

// Global error handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  // Don't prevent default - let ErrorBoundary handle it
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
